export class URLsConfig{
   // public WebAPIURL_Test = 'https://localhost:7177/';
//    public WebReportsURL = 'http://desktop-se4svqd:81/ReportServer';
//    public StaticFilepath = 'https://localhost:7177/StaticFiles/';

  public WebAPIURL_Test = 'http://37.61.217.5:8080/';
  public WebReportsURL = 'http://37.61.217.5:90/ReportServer';
  public StaticFilepath = 'http://37.61.217.5:8080/StaticFiles/';

       username_1 : any  = encodeURIComponent('Administrator');
       password_1 : any  = encodeURIComponent('CocR!ght$6078');  // will encode special characters

      public WebRepor_ServertURL_Focu =  `http://${this.username_1}:${this.password_1}@37.61.217.5:90/ReportServer/Pages/ReportViewer.aspx?%2fCocReports%2f`;

}

